export default "__VITE_ASSET__B52r2eFg__"